import React from 'react'
import Img1 from '../../Images/HR/BODMember/NageshPokharel.jpg'
import Img2 from '../../Images/HR/Staffs/HirachandraPokhrelDone.JPG'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Pagination } from 'swiper/modules'
import '../../css/testimonialpage.css'

import "swiper/css";
import "swiper/css/pagination"
import "swiper/css/autoplay"

const TestimonialPage = () => {

    const testimonialData = [
        {
            id: '1',
            message: `हाम्रो परिकल्पना - “ समुदायमा आधारित, उत्कृष्ट, प्रतिश्पर्धी एवम् दिगो वित्तीय सहकारी संस्था ”`,
            message1: 'Our Vision - " Community Based, Excellent, Competitive and Sustainable Financial Co- Operative Society "',
            photo: Img1,
            altName: 'cover-img',
            titleName: 'नागेश पोखरेल',
            post: 'अध्यक्ष'
        },
        {
            id: '2',
            message: 'हाम्रो लक्ष्य - “ सहकारी मुल्य ,मान्यता र सिद्धान्तको आधारमा प्रविधि मैत्री वित्तीय तथा गैह्र वित्तीय सेवा मार्फत सदस्यहरूको आर्थिक जीवनस्तर उकास्ने ”',
            message1: 'Our Mission - “ To raise the financial standard of living of members through technology, friendly, financial and non-financial services based on co-operative values, beliefs and principles "',
            photo: Img1,
            altName: 'cover-img',
            titleName: 'नागेश पोखरेल',
            post: 'अध्यक्ष'
        }
    ]

    return (
        <>
            <div className='testimonial-div'>
                <div className='testimonial-body'>
                    <Swiper
                        slidesPerView={1}
                        spaceBetween={20}
                        loop={true}
                        pagination={{ clickable: true, dynamicBullets: true }}
                        autoplay={{
                            delay: 10000,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true
                        }}
                        modules={[Autoplay, Pagination]}>
                        {testimonialData.map((item, index) => {
                            return (
                                <SwiperSlide key={index} className='card-1'>
                                    <div className='quote'>
                                        <p>{item.message}</p>
                                        <span>{item.message1}</span>
                                    </div>
                                    <div className='testi-body'>
                                        <div className='testi-body-img'>
                                            <img src={item.photo} alt={item.altName} />
                                        </div>
                                        <div className='testi-body-name'>
                                            <h3>{item.titleName}</h3>
                                            <span>{item.post}</span>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            )
                        })}
                    </Swiper>
                </div>
                <div className='testimonial-right' data-aos='fade-right'>
                    <div className='technical-header'>
                        <h3><span>सुचना अधिकारी</span></h3>
                    </div>
                    <div className='technical-body'>
                        <div className='technical-body-img'>
                            <img src={Img2} alt='cover-img' />
                        </div>
                        <div className='technical-body-detail'>
                            <h3>हिराचन्द्र पोखरेल</h3>
                            <h4>९८५२०६२२८८, ९८०७००२२८८</h4>
                            <h4>klsaccoun2077@gmail.com</h4>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TestimonialPage